import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
} from '@chakra-ui/react';
import React from 'react';

const ErrorAlert = ({ error }: { error?: Error }) => {
  if (!error) return null;
  return (
    <Alert status="error" flexDirection="column">
      <AlertIcon />
      <AlertTitle>Something went wrong</AlertTitle>
      <AlertDescription>
        Please try again or contact <a href="mailto:support@getintheloop.ca">support@getintheloop.ca</a>.
      </AlertDescription>
    </Alert>
  );
};

export default ErrorAlert;
